import { render, staticRenderFns } from "./ClausesAdd.vue?vue&type=template&id=346e0b9b"
import script from "./ClausesAdd.vue?vue&type=script&lang=js"
export * from "./ClausesAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports